import {Box} from '@mui/material';
import {func, object} from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import DropTarget from './compare-drop.jsx';
import CompareMetaCard from './compare-meta-card.jsx';

import CompareSwitcher from './compare-switcher.jsx';
import {setCompareSubject} from '@explorer/actions/compare';
import {setProcess} from '@explorer/actions/tiles';
import {COMPARE_TYPES} from '@explorer/constants';
import {getFullCompareSubjects} from '@explorer/selectors/compare';
import {otherCompareIndex, subjectsAreEqual} from '@explorer/util/compare';

const acceptedTypes = Object.values(COMPARE_TYPES);

const CompareMode = ({subjects, ...props}) => {
  const onCompareDrop = (index, item, type) => {
    const subject = {
      type,
      id: item.id,
      item,
    };

    if (type === COMPARE_TYPES.SCENE) {
      subject.parent = item.resultId;
    } else if (type === COMPARE_TYPES.MOSAIC) {
      subject.parent = item.seriesId;
      if (!item.supports.indexes) {
        props.setProcess(null);
      }
    }

    if (subjectsAreEqual(subject, index, subjects)) {
      props.setCompareSubject({
        index: otherCompareIndex(index),
        subject: subjects[index],
      });
    }

    props.setCompareSubject({
      index,
      subject,
    });
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          position: 'absolute',
          height: '100%',
          width: '100%',
        }}
      >
        <DropTarget
          accept={acceptedTypes}
          open={!subjects[0]}
          side="left"
          onDrop={(item, monitor) =>
            onCompareDrop(0, item, monitor.getItemType())
          }
          data-cy="compare-drop-target"
        />
        <DropTarget
          accept={acceptedTypes}
          open={!subjects[1]}
          onDrop={(item, monitor) =>
            onCompareDrop(1, item, monitor.getItemType())
          }
          side="right"
          data-cy="compare-drop-target"
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          justifyContent: 'flex-end',
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            padding: 1,
            zIndex: 2,
            pointerEvents: 'all',
          }}
          data-cy="compare-mode-meta"
        >
          <CompareMetaCard subject={subjects[0]} index={0} />
          <CompareSwitcher />
          <CompareMetaCard subject={subjects[1]} index={1} />
        </Box>
      </Box>
    </React.Fragment>
  );
};

CompareMode.propTypes = {
  setCompareSubject: func,
  subjects: object.isRequired,
  setProcess: func,
};

const mapStateToProps = state => ({
  subjects: getFullCompareSubjects(state),
  mapSize: state.ui.size,
});

const mapDispatchProps = {
  setCompareSubject,
  setProcess,
};

export default connect(mapStateToProps, mapDispatchProps)(CompareMode);
